// extracted by mini-css-extract-plugin
export default {"skeleton-round":"fde383","pulse":"cfd44a"};